// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rM7o","label":"styles_label__1qJ1s"};